<div class="wrapper wrapper-content mtv-property-company-page row">
    <div class="ibox mainPartPage"
        [ngStyle]="{width: propertyService.isShowView ? 'calc(100% - 470px)' : '100%'}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="getActiveTabTitle()"></filter>
                </div>
                <properties-filter *ngIf="currentTabId === 'property'"></properties-filter>
                <div *ngIf="propertyService.account.isUserAdmin() || propertyService.account.isUserCompanyAdmin()"
                     class="{{currentTabId === 'property' ? 'col-sm-3' : 'col-sm-5'}}">
                    <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="createNew()">
                        <i class="fa fa-plus-circle"></i> Add {{getActiveTabTitle()}}
                    </button>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item title="Properties" [tabId]="'property'" [active]="true">
                    <property-list *ngIf="currentTabId === 'property'"></property-list>
                </tab-item>
                <tab-item title="Corporations" [tabId]="'propertyGroup'">
                    <property-group-list *ngIf="currentTabId === 'propertyGroup'"></property-group-list>
                </tab-item>
            </tabs-wrapper>

            <pagination *ngIf="propertyService.total && !propertyService.spinnerShow" [total]="propertyService.total">
            </pagination>
        </div>
        <div class="animated animated-directory detailed-view dv-sidebar" *ngIf="propertyService.isShowView">
            <item-view *ngIf="currentTabId == 'property'"
                       [itemData]="propertyService.viewedItem"
                       [close]="closeDetails.bind(this)">
            </item-view>
            <corporation-detailed-view *ngIf="currentTabId == 'propertyGroup'"
                                       [corporation]="propertyService.viewedItem"
                                       (closeEvent)="closeDetails()">
            </corporation-detailed-view>
        </div>
    </div>
</div>
<property-modal *ngIf="propertyService.isCreateNew" (onClose)="closeCreateNew()"></property-modal>
<welcome-message-modal *ngIf="propertyService.isWelcomeModalShow"></welcome-message-modal>
<invitation-email-modal *ngIf="propertyService.isInvitationEmailModalShow"></invitation-email-modal>
<set-contact-us-modal *ngIf="propertyService.contactUsModalShow"></set-contact-us-modal>

<custom-theme-modal *ngIf="propertyService.customThemeModalShow"></custom-theme-modal>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property.component.html